if (jQuery('.case-slider').length > 0) {
    require(['swiper'], function (Swiper) {
        new Swiper('.case-slider', {
            effect: 'fade',
            fade: {
                crossFade: true
            },
            speed: 800,
            loop: true,
            autoplay: 6000,
            autoHeight: false,
            keyboardControl: true,
            iOSEdgeSwipeDetection: true,
            followFinger: false
        });
    })
}

// Homepage preContact function
// Set values into full contact form
window.preContact = function () {
    var pre_email = jQuery('#pre-email');
    var pre_phone = jQuery('#pre-phone');
    jQuery('input[name="email"]')
        .attr('value', pre_email.val())
        .attr('class', pre_email.attr('class'));
    jQuery('input[name="phone"]')
        .attr('value', pre_phone.val())
        .attr('class', pre_phone.attr('class'));
    jQuery('html, body').scrollTop($('#contact').offset().top)
    jQuery('#message').focus();
};

jQuery(document).ready(function () {
    /**
     * Bootstrap dropdown
     */
    (function () {
        jQuery('.dropdown-toggle').dropdown();
    })();

    // Navigation bar scrolling
    var navHeight = 60;
    if (jQuery(window).scrollTop() > navHeight) {
        jQuery('header.top').addClass('scrolled');
    }
    else {
        jQuery('header.top').removeClass('scrolled');
    }
    jQuery(window).bind('scroll', function () {
        var navHeight = 60;
        if (jQuery(window).scrollTop() > navHeight) {
            jQuery('header.top').addClass('scrolled');
        }
        else {
            jQuery('header.top').removeClass('scrolled');
        }
    });
    // Scroll-in animations
    var jQueryscrollAnimation = jQuery('.scroll');

    // Enable scroll animation when inside viewport
    jQuery(window).on('scroll', function () {
        jQueryscrollAnimation.each(function () {
            if (jQuery(this).offset().top <= jQuery(window).scrollTop() + jQuery(window).height() * 0.50) {
                jQuery(this).addClass('animate');
            }
        });
    });

    // Responsive / mobile menu trigger
    jQuery(".menu-trigger").click(function () {
        jQuery(this).toggleClass('closed');
        jQuery(this).parents().find("ul.menu").toggleClass('show');
    });

    // Cases page

    // Case overlay more info animation
    jQuery(".case-item .btn-read-more-open").click(function () {
        jQuery(this).parents().closest('.case-item').toggleClass('open');
    });

    jQuery(".case-item .close").click(function () {
        jQuery(this).parents().closest('.case-item').toggleClass('open');
    });

    // Input animations

    jQuery('input').each(function () {
        if (jQuery(this).val() !== '') {
            jQuery(this).addClass('active')
        }
    });
    jQuery('textarea').each(function () {
        if (jQuery(this).val() !== '') {
            jQuery(this).addClass('active')
        }
    });

    jQuery('input').on('blur', function () {
        if (jQuery(this).val() === '') {
            jQuery(this).removeClass('active').addClass('inactive');
        }
    }).on('focus', function () {
        jQuery(this).removeClass('inactive').addClass('active');
    });

    jQuery('label').bind('click', function () {
        var name = jQuery(this).attr('for');
        var form = jQuery('form');

        form.find('input[name="' + name + '"]').removeClass('inactive').addClass('active').focus();
    });

    jQuery('textarea').on('blur', function () {
        if (jQuery(this).val() === '') {
            jQuery(this).removeClass('active').addClass('inactive');
        }
    }).on('focus', function () {
        jQuery(this).removeClass('inactive').addClass('active');
    });

    // Email validation
    function isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#jQuery%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#jQuery%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?jQuery/i;
        return pattern.test(emailAddress);
    }


    jQuery('input[name="email"]').on('blur', function () {
        var val = jQuery(this).val();
        if (isValidEmailAddress(val)) {
            jQuery(this).removeClass('invalid').addClass('valid');
        }
        else if (val !== '') {
            jQuery(this).removeClass('valid').addClass('invalid');
        }
    });

    jQuery('input[name="pre-email"]').on('blur', function () {
        var val = jQuery(this).val();
        if (isValidEmailAddress(val)) {
            jQuery(this).removeClass('invalid').addClass('valid');
        }
        else if (val !== '') {
            jQuery(this).removeClass('valid').addClass('invalid');
        }
    });

    // Phone validation
    function isValidPhoneNumber(phoneNumber) {
        if (phoneNumber !== null) {
            var match = phoneNumber.match(/\d/g);
            if (match) {
                return match.length >= 10;
            }
        }
        return false;
    }

    jQuery('input[name="pre-phone"]').on('blur', function () {
        var val = jQuery(this).val();
        if (isValidPhoneNumber(val)) {
            jQuery(this).removeClass('invalid').addClass('valid');
        }
        else if (val !== '') {
            jQuery(this).removeClass('valid').addClass('invalid');
        }
    });

    jQuery('input[name="phone"]').on('blur', function () {
        var val = jQuery(this).val();
        if (isValidPhoneNumber(val)) {
            jQuery(this).removeClass('invalid').addClass('valid');
        }
        else if (val !== '') {
            jQuery(this).removeClass('valid').addClass('invalid');
        }
    });

    // Interactive iPhone slides
    var activeScreen = 'top-left';

    var topLeft = jQuery('.top-left');
    var screenTopLeft = jQuery('.topleft');
    var topRight = jQuery('.top-right');
    var screenTopRight = jQuery('.topright');
    var bottomLeft = jQuery('.bottom-left');
    var screenBottomLeft = jQuery('.bottomleft');
    var bottomRight = jQuery('.bottom-right');
    var screenBottomRight = jQuery('.bottomright');

    function moveToNextSlide() {
        if (activeScreen == 'top-left') {
            activeScreen = 'bottom-left';
        }
        else if (activeScreen == 'bottom-left') {
            activeScreen = 'top-right';
        }
        else if (activeScreen == 'top-right') {
            activeScreen = 'bottom-right';
        }
        else if (activeScreen == 'bottom-right') {
            activeScreen = 'top-left';
        }
        renderActiveSlide();
    }

    var autoplay = setInterval(function () {
        moveToNextSlide()
    }, 4000);


    function renderActiveSlide() {
        switch (activeScreen) {
            case 'top-left' :
                topLeft.addClass('active');
                screenTopLeft.fadeIn();
                topRight.removeClass('active');
                screenTopRight.fadeOut();
                bottomLeft.removeClass('active');
                screenBottomLeft.fadeOut();
                bottomRight.removeClass('active');
                screenBottomRight.fadeOut();
                break;
            case 'top-right' :
                topRight.addClass('active');
                screenTopRight.fadeIn();
                topLeft.removeClass('active');
                screenTopLeft.fadeOut();
                bottomLeft.removeClass('active');
                screenBottomLeft.fadeOut();
                bottomRight.removeClass('active');
                screenBottomRight.fadeOut();
                break;
            case 'bottom-left' :
                bottomLeft.addClass('active');
                screenBottomLeft.fadeIn();
                topLeft.removeClass('active');
                screenTopLeft.fadeOut();
                topRight.removeClass('active');
                screenTopRight.fadeOut();
                bottomRight.removeClass('active');
                screenBottomRight.fadeOut();
                break;
            case 'bottom-right' :
                bottomRight.addClass('active');
                screenBottomRight.fadeIn();
                topLeft.removeClass('active');
                screenTopLeft.fadeOut();
                topRight.removeClass('active');
                screenTopRight.fadeOut();
                bottomLeft.removeClass('active');
                screenBottomLeft.fadeOut();
                break;
        }
    }

    jQuery('.interactive-iphone').mousemove(function () {
        clearInterval(autoplay);
        topLeft.on('mouseenter', function () {
            activeScreen = 'top-left';
            renderActiveSlide();
        });

        topRight.on('mouseenter', function () {
            activeScreen = 'top-right';
            renderActiveSlide();
        });

        bottomLeft.on('mouseenter', function () {
            activeScreen = 'bottom-left';
            renderActiveSlide();
        });

        bottomRight.on('mouseenter', function () {
            activeScreen = 'bottom-right';
            renderActiveSlide();
        });
    }).mouseleave(function () {
        autoplay = setInterval(function () {
            moveToNextSlide()
        }, 4000);
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/misc/static/static.js